'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, FormControl, FormLabel, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { FormTextField } from '@/components/form/formTextField';
import { emailValidation, isValidEmail } from '@/components/form/validation/emailValidation';
import { Link } from '@/components/shared/link';
import { inputSx } from '../fieldStyles';
import { LoginCard } from '../loginCard';
import { SsoDropdown } from '../ssoDropdown';
export const CredentialsStep = t0 => {
  const $ = _c(18);
  const {
    error,
    submitting,
    ssoProviders,
    ssoOnly,
    onSubmit
  } = t0;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let t1;
  if ($[0] !== email || $[1] !== onSubmit || $[2] !== password) {
    t1 = () => {
      if (isValidEmail(email) && password) {
        onSubmit(email, password);
      }
    };
    $[0] = email;
    $[1] = onSubmit;
    $[2] = password;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const submit = t1;
  let t2;
  if ($[4] !== ssoOnly || $[5] !== ssoProviders) {
    t2 = ssoProviders.length > 0 ? <SsoDropdown providers={ssoProviders} /> : ssoOnly && <Typography variant="body1" className="text-center" data-testid="login-v2-no-sso-providers">No SSO providers are configured.</Typography>;
    $[4] = ssoOnly;
    $[5] = ssoProviders;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== email || $[8] !== password || $[9] !== ssoOnly || $[10] !== ssoProviders.length || $[11] !== submit || $[12] !== submitting) {
    t3 = !ssoOnly && <><Typography variant="subtitle1" className="text-center">{ssoProviders.length > 0 ? "Or use your email account:" : "Login with your email account:"}</Typography><Stack component="form" onSubmit={event => {
        event.preventDefault();
        submit();
      }} sx={{
        width: "100%",
        gap: "40px"
      }}><Stack sx={{
          gap: "12px"
        }}><FormTextField autoFocus={true} title="Email" placeholder="name@company.com" dataTestId="login-v2-email" validation={emailValidation} value={email} onChange={e => setEmail(e.target.value)} sx={inputSx} /><FormControl size="small" className="w-full"><FormLabel htmlFor="login-v2-password">Password</FormLabel><TextField type="password" autoComplete="current-password" value={password} onChange={e_0 => setPassword(e_0.target.value)} sx={inputSx} slotProps={{
              htmlInput: {
                id: "login-v2-password",
                "data-testid": "login-v2-password"
              }
            }} /></FormControl></Stack><Stack direction="row" sx={{
          gap: "24px",
          width: "100%"
        }}><Button variant="text" component={Link} href={`/login-v2/forgot-password?email=${encodeURIComponent(email)}`} sx={{
            flex: 1,
            height: "48px"
          }}>Forgot Password?</Button><Button type="submit" variant="contained" disabled={!isValidEmail(email) || !password || submitting} data-testid="login-v2-submit" sx={{
            flex: 1,
            height: "48px"
          }}>{submitting ? "Signing in\u2026" : "Log In"}</Button></Stack></Stack></>;
    $[7] = email;
    $[8] = password;
    $[9] = ssoOnly;
    $[10] = ssoProviders.length;
    $[11] = submit;
    $[12] = submitting;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== error || $[15] !== t2 || $[16] !== t3) {
    t4 = <LoginCard error={error}>{t2}{t3}</LoginCard>;
    $[14] = error;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};